import { GxSpinner } from '@garpix/garpix-web-components-react'
import classNames from 'classnames'
import React from 'react'
import style from './styles/spinner.module.scss'

const BlockSpinner = ({
  color = 'red',
  className = ''
}): React.ReactElement => {
  return (
    <GxSpinner
      size='large'
      className={classNames({
        [style.block]: true,
        [style[`spinner_${color}`]]: true,
        [className]: Boolean(className)
      })}
    />
  )
}

export default BlockSpinner
